// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"66697611","850":"4b49dad9"}[chunkId] + ".chunk.css";
};